class CreateSubjectPayloadModel {
  constructor() {
    this.subject = {};
    this.subjectAssignee = {};
  }
}

class CreateSubjectModel {
  constructor() {
    this.subjectState = '';
    this.subjectInfo = {};
    this.locked = false;
    this.imagePath = '';
    this.imageName = '';
    this.videoPath = '';
    this.comingSoon = false;
    this.status = '';
    this.activityMessage = '';
    this.units = [];
    this.instructors = [];
  }
}

class CreateSubjectInfoModel {
  constructor() {
    this.subjectName = '';
    this.description = '';
  }
}

class CreateSubjectAssigneeModel {
  constructor() {
    this.subjectId = '';
    this.contentAdminId = '';
    this.contentDevelopers = [];
    this.contentUploaders = [];
  }
}

class CreateContentUserRoleModel {
  constructor() {
    this.userId = '';
    this.userName = '';
    this.role = '';
    this.image = '';
    this.operation = '';
  }
}

// Models to create the payload body for create unit api.
class CreateUnitModel {
  constructor() {
    this.active = true;
    this.status = '';
    this.topics = [];
    this.trial = false;
    this.unitName = '';
  }
}

class CreateTopicModel {
  constructor() {
    this.active = true;
    this.contents = [];
    this.status = '';
    this.topicName = '';
    this.trial = false;
  }
}

class CreateContentModel {
  constructor() {
    this.contentType = '';
    this.locked = false;
    this.quiz = null;
    this.subTopic = null;
  }
}

class CreateSubTopicModel {
  constructor() {
    this.active = true;
    this.description = '';
    this.numberOfVideos = 0;
    this.status = '';
    this.subTopicName = '';
    this.trial = false;
    this.videoDuration = 0;
  }
}

class CreateQuizModel {
  constructor() {
    this.name = '';
    this.quizId = '';
  }
}

class ApproveSubjectPayloadModel {
  constructor() {
    this.subjectId = '';
    this.subjectName = '';
  }
}

class SubTopicVideoDetailsModel {
  constructor() {
    this.videoName = '';
    this.videoDurationInSeconds = 0;
    this.hlsUrl = '';
    this.dashURL = '';
  }
}

class AttachVideoDetailsModel {
  constructor() {
    this.videoName = '';
    this.size = '';
    this.videoDurationInSecond = 0;
    this.videoId = '';
    this.subjectId = '';
  }
}

class AttachVideoModel {
  constructor() {
    this.subjectId = '';
    this.unitId = '';
    this.topicId = '';
    this.subTopicId = '';
    this.videoDetails = new AttachVideoDetailsModel();
  }
}

class SubjectDrawerFormModel {
  constructor() {
    this.subjectName = '';
    this.subjectDescription = '';
    this.assignees = [];
    this.instructors = [];
  }
}

class SubjectInstructorModel {
  constructor() {
    this.instructorFirstName = '';
    this.instructorLastName = '';
    this.qualification = '';
    this.imageLink = '';
  }
}

export {
  CreateSubjectPayloadModel,
  CreateSubjectModel,
  CreateSubjectInfoModel,
  CreateSubjectAssigneeModel,
  CreateContentUserRoleModel,
  CreateUnitModel,
  CreateTopicModel,
  CreateSubTopicModel,
  CreateQuizModel,
  CreateContentModel,
  SubTopicVideoDetailsModel,
  AttachVideoDetailsModel,
  AttachVideoModel,
  ApproveSubjectPayloadModel,
  SubjectDrawerFormModel,
  SubjectInstructorModel,
};
